import PaymentMethodsList from './PaymentMethodsList';

export default PaymentMethodsList;